import * as i0 from '@angular/core';
import { Injectable, Component, NgModule } from '@angular/core';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import { BehaviorSubject } from 'rxjs';

class AiHubLoaderService {
    constructor() {
        this.loader$ = new BehaviorSubject({ show: false });
        this.loadingProcessCount = 0;
    }
    show() {
        this.loadingProcessCount += 1;
        if (this.loadingProcessCount === 1) {
            this.loader$.next({ show: true });
        }
    }
    hide() {
        this.loadingProcessCount -= 1;
        if (this.loadingProcessCount <= 0) {
            this.loader$.next({ show: false });
        }
    }
}
AiHubLoaderService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: AiHubLoaderService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
AiHubLoaderService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: AiHubLoaderService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: AiHubLoaderService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

class AiHubLoaderComponent {
    constructor(loaderService) {
        this.loaderService = loaderService;
        this.show = false;
    }
    ngOnInit() {
        this.subscription = this.loaderService.loader$
            .subscribe((state) => {
            this.show = state.show;
        });
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}
AiHubLoaderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: AiHubLoaderComponent, deps: [{ token: AiHubLoaderService }], target: i0.ɵɵFactoryTarget.Component });
AiHubLoaderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: AiHubLoaderComponent, selector: "aihub-loader", ngImport: i0, template: "<div [class.hidden]=\"!show\">\n  <div class=\"loader-overlay\">\n    <div *ngIf=\"show\" class=\"loader\"></div>\n  </div>\n</div>\n", styles: [":host .loader-overlay{position:fixed;width:100%;z-index:500000;top:70px}:host .loader-overlay .loader{height:7px;width:100%;position:relative;overflow:hidden}:host .loader-overlay .loader:before{display:block;position:fixed;content:\"\";left:-200px;width:200px;height:7px;background-color:#86bc25;-webkit-animation:loading 2s linear infinite;animation:loading 2s linear infinite}@-webkit-keyframes loading{0%{left:-200px;width:30%}50%{width:30%}70%{width:70%}80%{left:50%}95%{left:120%}to{left:100%}}@keyframes loading{0%{left:-200px;width:30%}50%{width:30%}70%{width:70%}80%{left:50%}95%{left:120%}to{left:100%}}\n"], directives: [{ type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: AiHubLoaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'aihub-loader', template: "<div [class.hidden]=\"!show\">\n  <div class=\"loader-overlay\">\n    <div *ngIf=\"show\" class=\"loader\"></div>\n  </div>\n</div>\n", styles: [":host .loader-overlay{position:fixed;width:100%;z-index:500000;top:70px}:host .loader-overlay .loader{height:7px;width:100%;position:relative;overflow:hidden}:host .loader-overlay .loader:before{display:block;position:fixed;content:\"\";left:-200px;width:200px;height:7px;background-color:#86bc25;-webkit-animation:loading 2s linear infinite;animation:loading 2s linear infinite}@-webkit-keyframes loading{0%{left:-200px;width:30%}50%{width:30%}70%{width:70%}80%{left:50%}95%{left:120%}to{left:100%}}@keyframes loading{0%{left:-200px;width:30%}50%{width:30%}70%{width:70%}80%{left:50%}95%{left:120%}to{left:100%}}\n"] }]
        }], ctorParameters: function () { return [{ type: AiHubLoaderService }]; } });

class AiHubLoaderModule {
}
AiHubLoaderModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: AiHubLoaderModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AiHubLoaderModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: AiHubLoaderModule, declarations: [AiHubLoaderComponent], imports: [CommonModule], exports: [AiHubLoaderComponent] });
AiHubLoaderModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: AiHubLoaderModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: AiHubLoaderModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        AiHubLoaderComponent
                    ],
                    imports: [CommonModule],
                    exports: [
                        AiHubLoaderComponent
                    ]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { AiHubLoaderComponent, AiHubLoaderModule, AiHubLoaderService };
